import React, { useEffect, useState } from "react";
import Modal from "../Modal/Modal";
import { apiService } from "../../api/apiService";
import FormularzZmianyHasla from "./FormularzZmianyHasla";
import InformacjaHaslaO365 from "./InformacjaHaslaO365";
import styles from "./ZmianaHaslaOkno.module.css";

/**
 * [KA-14, przegląd bezpieczeństwa 2026-09-26 → HASLA-LOKALNE 2026-09-27] Zmiana WŁASNEGO hasła konta lokalnego.
 *
 * Decyzja właściciela: „pozwalaj im na zmiane i dla admina ale tylko dla lokalsow”. Okno pyta serwer o stan hasła
 * (`GET /users/me/password`): konto lokalne dostaje formularz z wymaganiami hasła pod polem i terminem ważności (45 dni),
 * konto Office 365 — informację, że hasło zmienia w Office 365. Po zmianie pozostałe urządzenia są wylogowane (ta
 * przeglądarka dostaje nową sesję). Okno zamyka się wyłącznie przyciskami ✕ / Anuluj / Zmień hasło (W-10).
 */
const ZmianaHaslaOkno = ({ isOpen, onClose, onZmieniono }) => {
    const [stan, setStan] = useState(null);
    const [blad, setBlad] = useState(false);

    useEffect(() => {
        if (!isOpen || typeof apiService.statusMojegoHasla !== "function") return undefined;
        let aktywny = true;
        setBlad(false);
        Promise.resolve(apiService.statusMojegoHasla())
            .then((res) => { if (aktywny) setStan(res?.data || {}); })
            .catch(() => { if (aktywny) setBlad(true); });
        return () => { aktywny = false; };
    }, [isOpen]);

    /* [HASLA-O365, właściciel 2026-09-28] FAIL-CLOSED: formularz WYŁĄCZNIE, gdy serwer potwierdził konto lokalne logujące się
       hasłem (`zmianaDozwolona === true`). BYŁO: formularz rysował się także bez stanu (ładowanie, błąd odczytu) — konto
       Office 365 dostawało pola „Obecne hasło / Nowe hasło”, a odmowę dopiero po wysłaniu. */
    const lokalne = stan?.zmianaDozwolona === true;
    const nielokalne = stan !== null && !lokalne;
    const wygasa = stan?.wygasaAt ? new Date(stan.wygasaAt).toLocaleDateString("pl-PL") : null;

    const poZmianie = (komunikat) => {
        if (typeof onZmieniono === "function") onZmieniono(komunikat);
        onClose();
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} title="Zmień hasło" width="460px">
            {blad || (!lokalne && !nielokalne) ? (
                <div className={styles.formularz}>
                    <p className={styles.opis} role={blad ? "alert" : "status"}>
                        {blad
                            ? "Nie udało się sprawdzić, czy Twoje konto loguje się hasłem aplikacji. Zamknij okno i spróbuj ponownie za chwilę."
                            : "Sprawdzam, czy Twoje konto loguje się hasłem aplikacji…"}
                    </p>
                    <div className={styles.przyciski}>
                        <button type="button" className={styles.ghostBtn} onClick={onClose}>Zamknij</button>
                    </div>
                </div>
            ) : nielokalne ? (
                <div className={styles.formularz}>
                    <InformacjaHaslaO365 />
                    <div className={styles.przyciski}>
                        <button type="button" className={styles.ghostBtn} onClick={onClose}>Zamknij</button>
                    </div>
                </div>
            ) : (
                <>
                    <p className={styles.opis}>
                        Po zmianie hasła pozostałe urządzenia zostaną wylogowane. Hasło konta lokalnego jest ważne
                        {" "}{stan?.waznoscDni || 45} dni{wygasa ? ` — obecne wygasa ${wygasa}` : ""}.
                    </p>
                    <FormularzZmianyHasla wymagania={stan?.wymagania} onZmieniono={poZmianie} onAnuluj={onClose} />
                </>
            )}
        </Modal>
    );
};

export default ZmianaHaslaOkno;
